import type { FeatureFlagService } from "../services/feature-flags";
import type { TrainingModule, ModuleView } from "../modules/types";
import { resolveModuleView } from "../modules/types";

export interface ShellView {
  readonly modules: readonly ModuleView[];
  readonly title: "ATLas";
}

export function buildShellView(
  modules: readonly TrainingModule[],
  flags: FeatureFlagService,
): ShellView {
  return {
    title: "ATLas",
    modules: modules.map((module) => resolveModuleView(module, flags)),
  };
}
